import { Component, OnInit, Inject, ViewChild, Optional, OnDestroy, HostListener, ViewEncapsulation } from '@angular/core';
import { UntypedFormControl, Validators, UntypedFormGroup, UntypedFormBuilder, UntypedFormArray, FormControl } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatRadioButton } from '@angular/material/radio';
import { MatCheckbox } from '@angular/material/checkbox';

import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';

import { CookieService } from 'ngx-cookie-service';
import { LoggingService } from '@EfsServices/logging.service';
import { DataSharingService } from '../shared/services/data-sharing.service';
import { EfsApiService } from '@EfsServices/efs-api.service';
import { environment } from '@efsEnvironments/environment';
import { GenericPopupComponent } from '@EfsReusable/generic-popup/generic-popup.component';
import { ApiErrorHandlingService } from '@EfsServices/api-error-handling.service';
import { SessionTimerService } from '@EfsServices/session-timer.service';
import { PermissionHandlingService } from '@efsShared/services/permission-handling.service';

@Component({
    selector: 'app-parameter-entry',
    templateUrl: './parameter-entry.component.html',
    styleUrls: ['./parameter-entry.component.css'],
    standalone: false
})
export class ParameterEntryComponent {
  moduleInfo = {
    moduleName: 'parameterEntry',
    moduleVersion: '0.2.0',
  };

  foldDiameterParameterControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('[0-9\\-/\\s]+'),
    Validators.required,
  ]);

  formSizeDescParameterControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^(?=.*[A-Za-z0-9])[A-Za-z0-9 .-\_]+$'), // At least one alphanumeric character, spaces allowed
    Validators.required,
  ]);

  formSizeWidthParameterControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]+(\.[0-9]+)?$'),  // Allows numbers with optional decimal point
    Validators.required,
  ]);

  formSizeLengthParameterControl = new UntypedFormControl({ value: '', disabled: false }, [
    Validators.pattern('^[0-9]+(\.[0-9]+)?$'), // Allows numbers with optional decimal point
    Validators.required,
  ]);

  foldDiameterSubmitDisable = true;
  formSizeSubmitDisable = true;

  constructor(
    private dataSharingService: DataSharingService,
    private cookieService: CookieService,
    private router: Router,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
    private efsApiService: EfsApiService,
    public dialog: MatDialog,
    public loggingService: LoggingService,
    private apiErrorHandlingService: ApiErrorHandlingService,
    private sessionTimerService: SessionTimerService,
    private formBuilder: UntypedFormBuilder,
    public permissionHandlingService: PermissionHandlingService,
  ) {
    // this.form = this.formBuilder.group({
    //   checkBoxes: new UntypedFormArray([], [
    //     // Validators.required
    //   ])
    // });
  }

  ngOnInit(): void {
    this.dataSharingService.shareData(this.moduleInfo); // share name and version of module; update here
    this.loggingService.logInfo('In Parameter Entry page');

    // touch all fields to activate required status

    this.checkForInvalidInput();


    // session timer startup for detecting session
    this.sessionTimer();
  }

  // session timer method for tracking session using mouse movement
  @HostListener('mousemove')
  sessionTimer() {
    this.sessionTimerService.checkSessionStatus();
  }
  // stop session timers once the modal is removed
  ngOnDestroy(): void {
    this.sessionTimerService.stopTimers();
  }

  // services
  serviceAddFoldDiameter(foldDiameterBody) {
    console.log(JSON.stringify(foldDiameterBody));

    this.efsApiService.addFoldDiameter(foldDiameterBody).subscribe({
      next: (response) => {
        console.log(response);
        this.popupWarning(false, 'Successfully added New Fold Diameter');
        this.foldDiameterSubmitDisable = false;
        this.foldDiameterParameterControl.reset();
      },
      error: (error) => {
        this.foldDiameterSubmitDisable = false;
        this.apiErrorHandlingService.errorStatusHandler(error);
      }
    });
  }
  serviceAddFormSize(formSizeBody) {
    console.log(JSON.stringify(formSizeBody));

    this.efsApiService.addFormSize(formSizeBody).subscribe({
      next: (response) => {
        console.log(response);
        this.popupWarning(false, 'Successfully added New Form Size');
        this.formSizeSubmitDisable = false;
        this.formSizeDescParameterControl.reset();
        this.formSizeWidthParameterControl.reset();
        this.formSizeLengthParameterControl.reset();
      },
      error: (error) => {
        this.formSizeSubmitDisable = false;
        this.apiErrorHandlingService.errorStatusHandler(error);
      }
    });


  }

  // end of services

  toggleSubmitButton() {
    
  }

  // disable buttons if inputs are invalid
  checkForInvalidInput() {
    // this.foldDiameterParameterControl.markAsTouched();
    // this.formSizeDescParameterControl.markAsTouched();
    // this.formSizeWidthParameterControl.markAsTouched();
    // this.formSizeLengthParameterControl.markAsTouched();

    this.foldDiameterParameterControl.valueChanges.subscribe((input) => {
      if (this.foldDiameterParameterControl.status === 'INVALID') {
        this.foldDiameterSubmitDisable = true;
      } else {
        this.foldDiameterSubmitDisable = false;
      }
    });

    // if (this.formSizeDescParameterControl.status === 'INVALID' &&
    //   this.formSizeWidthParameterControl.status === 'INVALID' &&
    //   this.formSizeLengthParameterControl.status === 'INVALID'
    // ) {
    //   this.foldDiameterSubmitDisable = true;
    // } else {
    //   this.foldDiameterSubmitDisable = false;
    // }


    this.formSizeDescParameterControl.valueChanges.subscribe((input) => {
      if (this.formSizeDescParameterControl.status === 'INVALID' ||
        this.formSizeWidthParameterControl.status === 'INVALID' ||
        this.formSizeLengthParameterControl.status === 'INVALID') {
        this.formSizeSubmitDisable = true;
      } else {
        this.formSizeSubmitDisable = false;
      }
    });
    this.formSizeWidthParameterControl.valueChanges.subscribe((input) => {
      if (this.formSizeDescParameterControl.status === 'INVALID' ||
        this.formSizeWidthParameterControl.status === 'INVALID' ||
        this.formSizeLengthParameterControl.status === 'INVALID') {
        this.formSizeSubmitDisable = true;
      } else {
        this.formSizeSubmitDisable = false;
      }
    });
    this.formSizeLengthParameterControl.valueChanges.subscribe((input) => {
      if (this.formSizeDescParameterControl.status === 'INVALID' ||
        this.formSizeWidthParameterControl.status === 'INVALID' ||
        this.formSizeLengthParameterControl.status === 'INVALID') {
        this.formSizeSubmitDisable = true;
      } else {
        this.formSizeSubmitDisable = false;
      }
    });
  }


  submitFoldDiameterButton() {
    this.foldDiameterSubmitDisable = true;

    const foldDiameterBody = {
      foldDiameterDesc: this.foldDiameterParameterControl.value.trim(),
    }
    this.serviceAddFoldDiameter(foldDiameterBody)
  }

  submitFormSizeButton() {
    this.formSizeSubmitDisable = true;
    const formSizeBody = {
      formSizeDesc: this.formSizeDescParameterControl.value,
      formWidth: this.formSizeWidthParameterControl.value.trim(),
      formLength: this.formSizeLengthParameterControl.value.trim(),
    }
    this.serviceAddFormSize(formSizeBody);

  }

  popupWarning(questionType, message) {
    const popupDialogRef = this.dialog.open(GenericPopupComponent, {
      width: '450px',
      height: '250px',
      panelClass: 'popup-borders',
      data: {
        questionType,
        title: 'Alert',
        message
      }
    });
    // return true;
  }
}
